/* eslint-disable react/react-in-jsx-scope */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import moment from 'moment-timezone';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';

import Days from './days';
import Schedules from './schedules';

import { type TimelineProps } from '../../common/types';
import { calculateDays, filterSchedules, normalizeDate, localMidnight } from '../../common/utils';
import { TimelineContainer, BodyHead, BodyContent, RotationLabels, Marker } from './styled';

const styles = css({
	display: 'block',
	width: '100%',
	overflow: 'hidden',
	whiteSpace: 'nowrap',
	textOverflow: 'ellipsis',
});
export function Timeline({
	startDate,
	currentDate,
	timezone,
	interval = 2,
	intervalUnit = 'weeks',
	rotations,
	dateFormat,
	locale,
}: TimelineProps) {
	const days = calculateDays(startDate, timezone, interval, intervalUnit);
	const filteredRotations = rotations.map(({ name, periods }) => ({
		name,
		periods: filterSchedules(periods, startDate, timezone, days),
	}));
	const localStartDate = localMidnight(startDate, timezone);
	const startDateMillis: number = normalizeDate(localStartDate, timezone).valueOf();

	const totalDuration: number = moment.duration(days, 'days').asMilliseconds();
	const markerTime: number = normalizeDate(currentDate, timezone).valueOf() - startDateMillis;

	return (
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
		<TimelineContainer className="body">
			{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
			<BodyHead className="body-head">
				<RotationLabels>
					{filteredRotations.map(({ name }) => (
						<li key={name}>
							<span css={styles} title={name}>
								{name}
							</span>
						</li>
					))}
				</RotationLabels>
			</BodyHead>
			{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
			<BodyContent className="body-content">
				<Days {...{ startDate, timezone, days, dateFormat, locale }} />
				<Schedules
					{...{
						startDate,
						currentDate,
						timezone,
						days,
						rotations: filteredRotations,
					}}
				/>
				{markerTime >= 0 && markerTime <= totalDuration ? (
					<Marker
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
						css={css({
							// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
							left: `${(markerTime / totalDuration) * 100}%`,
						})}
					/>
				) : null}
			</BodyContent>
		</TimelineContainer>
	);
}

export default Timeline;
